import BreadCrump from "../tools/breadcrump";
import { getCookies } from "cookies-next";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";
import { Button, Input } from 'rsuite';

export default function ListComments() {
    const { t } = useTranslation();
    const [key, setKey] = useState(1);

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Comments',
            url: '/dashboard/Comments'
        },
        {
            name: 'List Comments',
            url: null
        },
    ];

    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    };

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="List Comments"></HeaderOfPage>
            <div className="mt-6">
                <ListofComments key={key} reloaditem={reloadgame}></ListofComments>
            </div>
        </div>
    );
}

function ListofComments({ reloaditem }: { reloaditem: () => void }) {
    const { t } = useTranslation();
    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [publishFilter, setPublishFilter] = useState<string>('all'); // all, published, unpublished

    const load = async () => {
        setLoading(true);
        try {
            const queryParams = new URLSearchParams({
                page: currentPage.toString(),
            });
            
            if (publishFilter !== 'all') {
                queryParams.append('publish', publishFilter === 'published' ? 'true' : 'false');
            }

            const response = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/comments?${queryParams.toString()}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            setList(response.data.message);
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error loading comments'),
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, [currentPage, publishFilter]);

    const handlePublish = async (id: string, publish: boolean) => {
        try {
            await axios({
                method: 'put',
                url: `${config.url}/v1/dashboard/comments/${id}`,
                data: { publish },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: publish ? t('Comment published') : t('Comment unpublished'),
                timer: 1500,
                showConfirmButton: false
            });

            reloaditem();
            load();
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error updating comment'),
            });
        }
    };

    const handleDelete = async (id: string) => {
        const result = await Swal.fire({
            title: t('Are you sure?'),
            text: t('You will not be able to recover this comment!'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('Yes, delete it!'),
            cancelButtonText: t('Cancel')
        });

        if (result.isConfirmed) {
            try {
                await axios({
                    method: 'delete',
                    url: `${config.url}/v1/dashboard/comments/${id}`,
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                });

                Swal.fire({
                    icon: 'success',
                    title: t('Deleted!'),
                    text: t('Comment has been deleted.'),
                    timer: 1500,
                    showConfirmButton: false
                });

                reloaditem();
                load();
            } catch (error: any) {
                Swal.fire({
                    icon: 'error',
                    title: t('Error'),
                    text: error.response?.data?.message || t('Error deleting comment'),
                });
            }
        }
    };

    const handleAddReply = async (id: string, replyText: string, replyName: string) => {
        try {
            await axios({
                method: 'put',
                url: `${config.url}/v1/dashboard/comments/${id}`,
                data: {
                    reply: {
                        text: replyText,
                        name: replyName || 'Admin'
                    }
                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Reply added successfully'),
                timer: 1500,
                showConfirmButton: false
            });

            reloaditem();
            load();
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error adding reply'),
            });
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            {/* Filters */}
            <div className="mb-6 flex gap-4 items-center">
                <label className="text-sm font-medium text-gray-700">Filter:</label>
                <select
                    value={publishFilter}
                    onChange={(e) => {
                        setPublishFilter(e.target.value);
                        setCurrentPage(1);
                    }}
                    className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="all">{t('All Comments')}</option>
                    <option value="published">{t('Published')}</option>
                    <option value="unpublished">{t('Unpublished')}</option>
                </select>
            </div>

            {loading ? (
                <div className="text-center py-8">
                    <p className="text-gray-500">{t('Loading...')}</p>
                </div>
            ) : list && list.docs && list.docs.length > 0 ? (
                <>
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        {t('Name')}
                                    </th>
                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        {t('Product')}
                                    </th>
                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        {t('Comment')}
                                    </th>
                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        {t('Rating')}
                                    </th>
                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        {t('Status')}
                                    </th>
                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        {t('Actions')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {list.docs.map((item: any) => (
                                    <CommentRow
                                        key={item._id || item.id}
                                        item={item}
                                        onPublish={handlePublish}
                                        onDelete={handleDelete}
                                        onAddReply={handleAddReply}
                                        t={t}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    {list.totalPages > 1 && (
                        <div className="mt-6 flex justify-center gap-2">
                            <Button
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}
                            >
                                {t('Previous')}
                            </Button>
                            <span className="px-4 py-2">
                                {t('Page')} {currentPage} {t('of')} {list.totalPages}
                            </span>
                            <Button
                                disabled={currentPage === list.totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}
                            >
                                {t('Next')}
                            </Button>
                        </div>
                    )}
                </>
            ) : (
                <div className="text-center py-8">
                    <p className="text-gray-500">{t('No comments found')}</p>
                </div>
            )}
        </div>
    );
}

function CommentRow({ item, onPublish, onDelete, onAddReply, t }: any) {
    const [showReplyForm, setShowReplyForm] = useState(false);
    const [replyText, setReplyText] = useState('');
    const [replyName, setReplyName] = useState('Admin');

    const productName = item.toproduct?.name 
        ? (typeof item.toproduct.name === 'object' 
            ? item.toproduct.name.en || item.toproduct.name.fa || item.toproduct.name.ku || 'N/A'
            : item.toproduct.name)
        : 'N/A';

    const userName = item.touser 
        ? `${item.touser.name || ''} ${item.touser.lastname || ''}`.trim() || item.name
        : item.name || 'Guest';

    return (
        <tr className="hover:bg-gray-50">
            <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm font-medium text-gray-900">{userName}</div>
                {item.touser && (
                    <div className="text-sm text-gray-500">{item.touser.email}</div>
                )}
            </td>
            <td className="px-6 py-4">
                <div className="text-sm text-gray-900">{productName}</div>
                {item.toproduct?.code && (
                    <div className="text-sm text-gray-500">Code: {item.toproduct.code}</div>
                )}
            </td>
            <td className="px-6 py-4">
                <div className="text-sm text-gray-900 max-w-md">{item.text}</div>
                {item.image && (
                    <img src={`${config.url}/${item.image}`} alt="Comment" className="mt-2 h-20 w-20 object-cover rounded" />
                )}
                {item.reply && item.reply.text && (
                    <div className="mt-2 p-2 bg-blue-50 rounded">
                        <div className="text-xs font-semibold text-blue-800">{item.reply.name}:</div>
                        <div className="text-sm text-blue-700">{item.reply.text}</div>
                    </div>
                )}
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <span key={star} className={star <= (item.rating || 0) ? 'text-yellow-400' : 'text-gray-300'}>
                            ★
                        </span>
                    ))}
                </div>
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
                <span className={`px-2 py-1 text-xs rounded-full ${item.publish ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                    {item.publish ? t('Published') : t('Unpublished')}
                </span>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                <div className="flex flex-col gap-2">
                    <Button
                        size="sm"
                        color={item.publish ? 'orange' : 'green'}
                        onClick={() => onPublish(item._id || item.id, !item.publish)}
                    >
                        {item.publish ? t('Unpublish') : t('Publish')}
                    </Button>
                    <Button
                        size="sm"
                        color="blue"
                        onClick={() => setShowReplyForm(!showReplyForm)}
                    >
                        {item.reply && item.reply.text ? t('Edit Reply') : t('Add Reply')}
                    </Button>
                    <Button
                        size="sm"
                        color="red"
                        onClick={() => onDelete(item._id || item.id)}
                    >
                        {t('Delete')}
                    </Button>
                </div>
                {showReplyForm && (
                    <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                        <Input
                            placeholder={t('Reply Name')}
                            value={replyName}
                            onChange={(val) => setReplyName(val)}
                            className="mb-2"
                        />
                        <textarea
                            placeholder={t('Reply Text')}
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            className="w-full p-2 border rounded mb-2"
                            rows={3}
                        />
                        <div className="flex gap-2">
                            <Button
                                size="sm"
                                color="green"
                                onClick={() => {
                                    if (replyText.trim()) {
                                        onAddReply(item._id || item.id, replyText, replyName);
                                        setReplyText('');
                                        setShowReplyForm(false);
                                    }
                                }}
                            >
                                {t('Save Reply')}
                            </Button>
                            <Button
                                size="sm"
                                onClick={() => {
                                    setShowReplyForm(false);
                                    setReplyText('');
                                }}
                            >
                                {t('Cancel')}
                            </Button>
                        </div>
                    </div>
                )}
            </td>
        </tr>
    );
}

